module.exports = __webpack_public_path__ + "img/face-usecase-portrait.a934622d.webp";